import { connect } from 'react-redux';
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import OtpInput from 'react-otp-input';

import { Form, Input, Select, DatePicker, Button, Row, Col, Checkbox, Divider, Card, Icon, Modal } from 'antd';
import Container from '../../components/Container';
import { constants, validationRules, utils } from '../../devUtils';
import { PersonalAddressFormProps, PersonalAddressFormmapStateToProps } from './IndusindMinKycDataHandler';
import { consentText } from './constants';
import { StyledIndusindMinKyc } from './StyledIndusIndMinkyc';
import { StyledOtpGeneration } from '../PayBalance/StyledPayBalance';
import { YSCCARD_CONSTANTS } from '../YscCardActions/constants';
import { NETWORKCARD_CONSTANTS } from '../NetworkCards/constants';

const { CUSTOMER_SERVICE_NUMBER, CUSTOMER_SERVICE_TIMINGS, CUSTOMER_SERVICE } = YSCCARD_CONSTANTS;
const { CONTACT_CUSTOMER_CARE } = NETWORKCARD_CONSTANTS;

const { Option } = Select;
const { ConsentTextIndusInd } = consentText;

class PersonalAddressForm extends Component {
  constructor(props) {
    super(props);
    this.handleStateChange = this.handleStateChange.bind(this);
    this.handleWorkFormSubmit = this.handleWorkFormSubmit.bind(this);
    this.verifyYscOTP = this.verifyYscOTP.bind(this);
    this.handleOTPChangeYsc = this.handleOTPChangeYsc.bind(this);
    this.handleResendOTPYsc = this.handleResendOTPYsc.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.state = {
      consent: false,
      OTP: '',
      showResendText: false,
      remainingTime: 60,
      yscCardId: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    const {
      GenerateOtpIndusInd: _GenerateOtpIndusInd,
      OtpSubmitResponse: _OtpSubmitResponse,
      DedupeVerifySuccess: _DedupeVerifySuccess,
      UserDetails: _UserDetails,
      onGenerateYscOtp,
      history,
    } = this.props;
    const {
      GenerateOtpIndusInd,
      GenerateOtpIndusInd: {
        response: {
          ysc_card_id = '',
        } = {},
      } = {},
      OtpSubmitResponse,
      OtpSubmitResponse: {
        response: {
          errors = [],
        } = {},
      } = {},
      onInitUpdatedUserProfile,
      DedupeVerifySuccess,
      DedupeVerifySuccess: { status: verify_success } = {},
      UserDetails,
      UserDetails: { status: user_details_success } = {},
    } = nextProps;
    if (!utils.isEqual(GenerateOtpIndusInd, _GenerateOtpIndusInd) && ysc_card_id.length) {
      this.setState({ modalType: 'YSC_OTP_GENERATION' });
      this.setState({ yscCardId: ysc_card_id });
      this.startTimer();
    } else if (!utils.isEqual(OtpSubmitResponse, _OtpSubmitResponse) && errors && !errors.length) {
      onInitUpdatedUserProfile();
    } else if (!utils.isEqual(DedupeVerifySuccess, _DedupeVerifySuccess) && verify_success) {
      onGenerateYscOtp();
      this.setState({
        modalType: '',
        consent: false,
        OTP: '',
        showResendText: false,
        remainingTime: 60,
        yscCardId: '',
      });
    } else if (!utils.isEqual(UserDetails, _UserDetails) && user_details_success) {
      utils.forceRedirect(history, { pathname: constants.LINK_PAY_BALANCE });
    }
  }

  startTimer() {
    const {
      onGetOtpSuccess,
    } = this.props;
    this.timer = setInterval(() => {
      const { remainingTime } = this.state;
      if (remainingTime === 1) {
        clearInterval(this.timer);
        this.setState({ showResendText: true });
      }
      this.setState((prevState) => ({
        remainingTime: prevState.remainingTime - 1,
      }));
    }, 1000);
    onGetOtpSuccess();
  }

  handleOTPChangeYsc(OTP) {
    this.setState({ OTP });
  }

  handleModal(type) {
    this.setState({
      modalType: typeof (type) === 'string' ? type : '',
    });
  }

  handleResendOTPYsc() {
    const { onGenerateYscOtp } = this.props;
    onGenerateYscOtp();
    clearInterval(this.timer);
    this.setState({
      showResendText: false,
      remainingTime: 60,
    });
    this.startTimer();
  }

  verifyYscOTP() {
    const {
      onOtpCaptureAction,
      onResetPopup,
    } = this.props;
    const { OTP, yscCardId } = this.state;
    if (!OTP.length) {
      onResetPopup(constants.ALERT_FIELD_REQUIRED, 'error');
    } else if (OTP.length !== 6) {
      onResetPopup(constants.ALERT_OTP_MINIMUM_DIGITS, 'error');
    } else {
      const payload = {
        ysc_card_id: yscCardId,
        otp: OTP,
        action_type: 'add_card',
      };
      onOtpCaptureAction(payload);
    }
  }


  handleStateChange(selectedStateId) {
    const {
      onInitIndusindMinKycCities,
    } = this.props;
    onInitIndusindMinKycCities({ id: selectedStateId });
  }

  handleWorkFormSubmit(evt) {
    evt.preventDefault();
    const {
      MinKycUserDetails: {
        data: {
          document_types = [],
        } = {},
      } = {},
    } = this.props;
    const { consent } = this.state;
    const { form: { validateFields }, onDedupeVerify } = this.props;
    validateFields((err, values) => {
      const {
        address_document_number = '',
        address_proof_document_type = '',
        first_name = '',
        gender = '',
        last_name = '',
        dob = '',
      } = values;
      const payload = {
        address_document_number,
        address_proof_document_type: utils.lodashFind(document_types, { value: address_proof_document_type || {} }).key || '',
        first_name,
        gender: gender.toLowerCase(),
        last_name,
        dob: dob.format(constants.DATE_FORMAT_DDMMYYYY),
        user_consent: consent ? 'yes' : 'no',
      };
      if (!err) {
        onDedupeVerify(payload);
      }
    });
  }

  renderModalBody(type) {
    const {
      OTP,
      showResendText,
      remainingTime,
    } = this.state;
    const {
      UserDetails: {
        phone = '',
      } = {},
      isLoadingStatus = false,
    } = this.props;
    const formattedPhone = `XXXXXX${phone.slice(-4)}`;
    switch (type) {
      case 'YSC_OTP_GENERATION':
        return (
          <StyledOtpGeneration>
            <Card className="rounded otp-card margin-b-1">
              <Row align="top" type="flex" justify="start" gutter={10}>
                <Col xs={24} sm={24} md={2} lg={2} xl={2}>
                  <Icon type="check-circle" theme="filled" className="check-icon" />
                </Col>
                <Col xs={24} sm={24} md={22} lg={22} xl={22}>
                  <p className="font-14">OTP has been Successfully sent to <strong> {formattedPhone} </strong>.
                    Please Validate to Activate the Card to your account
                  </p>
                  <p className="font-12 text-red">
                    {CONTACT_CUSTOMER_CARE}
                  </p>
                </Col>
              </Row>
            </Card>
            <Row align="middle" type="flex" justify="center" gutter={10}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="margin-t-1 margin-b-1">
                <OtpInput
                  containerStyle={{ justifyContent: 'center' }}
                  className="custom-otp-inputs"
                  value={OTP}
                  onChange={(value) => this.handleOTPChangeYsc(value)}
                  numInputs={6}
                  separator={<span className="padding-1"></span>}
                  isInputNum
                />
              </Col>
              <div>
                {showResendText ? (
                  <span
                    role="presentation"
                    className="text-red"
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.handleResendOTPYsc()}
                  >
                    Resend OTP
                  </span>
                ) : (
                  <span> Resend OTP in 0 : {remainingTime} sec</span>
                )}
              </div>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                <Button
                  type="primary"
                  className="green-btn width-5 margin-t-1"
                  onClick={() => this.verifyYscOTP()}
                  loading={isLoadingStatus}
                >
                  Confirm
                </Button>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <p className="font-14 nomargin-bottom margin-t-2">
                  {CUSTOMER_SERVICE}<br />
                  <strong>{CUSTOMER_SERVICE_NUMBER}</strong><br />
                  {CUSTOMER_SERVICE_TIMINGS}
                </p>
              </Col>
            </Row>
          </StyledOtpGeneration>
        );
      default:
        return <div />;
    }
  }

  renderModalCloseFunction(modalType) {
    switch (modalType) {
      case 'YSC_OTP_GENERATION':
        return this.handleModal;
      default:
        return () => '';
    }
  }

  renderPersonalAddress() {
    const {
      form: {
        getFieldDecorator,
      } = {},
      isLoading = false,
      MinKycUserDetails: {
        data: {
          details: {
            address_document_number = '',
            address_proof_document_type = '',
            dob = '',
            first_name = '',
            gender = '',
            last_name = '',
          } = {},
          document_types = [],
          genders = [],
        } = {},
      } = {},
    } = this.props;
    const {
      consent,
    } = this.state;
    return (
      <StyledIndusindMinKyc>
        <Form
          onSubmit={this.handleWorkFormSubmit}
          className="steps-content"
          layout="vertical"
        >
          <Row align="middle" type="flex" justify="start" gutter={20}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <h2 className="title_style">IndusInd Bank Min KYC</h2>
            </Col>
          </Row>
          <Divider />
          <Row align="middle" type="flex" justify="start" gutter={20}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Row align="middle" type="flex" justify="start" gutter={30}>
                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                  <Form.Item label="First Name">
                    {getFieldDecorator('first_name', {
                      rules: [validationRules.validInputField],
                      initialValue: first_name || undefined,
                    })(
                      <Input
                        className="custom-input"
                        placeholder="Enter First Name"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                  <Form.Item label="Last name">
                    {getFieldDecorator('last_name', {
                      rules: [validationRules.validInputField],
                      initialValue: last_name || undefined,
                    })(
                      <Input
                        className="custom-input"
                        placeholder="Enter Last Name"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                  <Form.Item label="Gender">
                    {getFieldDecorator('gender', {
                      rules: [validationRules.mandatory],
                      initialValue: utils.capitalFirstCharacter(gender) || undefined,
                    })(
                      <Select
                        className="custom-select"
                        placeholder="Select Gender"
                      >
                        {genders && genders.length && genders.map(({ key = '', value = '' }) => (
                          <Option key={key} value={value}>
                            {value}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                  <Form.Item label="Date of Birth" >
                    {getFieldDecorator('dob', {
                      rules: [validationRules.dob_mandatory],
                      initialValue: dob ? utils.momentInstance(dob, constants.DATE_FORMAT_DDMMYYYY) : undefined,
                    })(
                      <DatePicker
                        className="custom-datepicker"
                        placeholder="Enter Date of Birth"
                        format={constants.DATE_FORMAT_DDMMYYYY}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        disabledDate={utils.disableDate}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row align="middle" type="flex" justify="start" gutter={30}>
              </Row>
              <Row align="middle" type="flex" justify="start" gutter={30}>
                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                  <Form.Item label="Address Proof Document Type">
                    {getFieldDecorator('address_proof_document_type', {
                      rules: [validationRules.mandatory],
                      initialValue: address_proof_document_type || undefined,
                    })(
                      <Select
                        className="custom-select"
                        placeholder="Select Address Proof Document Type"
                      >
                        {document_types && document_types.length && document_types.map(({ key = '', value = '' }) => (
                          <Option key={key} value={value}>
                            {value}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Fragment>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Address Document Number">
                      {getFieldDecorator('address_document_number', {
                        rules: [validationRules.validInputFieldAlphanumeric],
                        initialValue: address_document_number || undefined,
                      })(
                        <Input
                          className="custom-input"
                          placeholder="Enter Address Document Number"
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Fragment>
              </Row>
            </Col>
          </Row>
          <Row align="middle" type="flex" justify="start" gutter={10}>
            <Checkbox
              checked={consent}
              onChange={({ target: { checked } }) => this.setState({ consent: checked })}
            >
              {ConsentTextIndusInd}
            </Checkbox>
          </Row>
          <div className="text-right">
            <Button
              className="margin-1 width-2"
              type="default"
            >
              <Link
                to={constants.LINK_PAY_BALANCE}
              >
              Cancel
              </Link>
            </Button>
            <Button
              htmlType="submit"
              className="green-btn margin-1 width-2"
              disabled={!consent}
              loading={isLoading}
            >
              Send OTP
            </Button>
          </div>
        </Form>
      </StyledIndusindMinKyc>
    );
  }

  render() {
    const { modalType } = this.state;
    return (
      <div>
        <Container>
          <Modal
            visible={!!modalType}
            onCancel={this.renderModalCloseFunction(modalType)}
            size="sm"
            classname="default-popup"
            title={null}
            footer={null}
            maskClosable={false}
            width="600px"
          >
            {modalType && this.renderModalBody(modalType)}
          </Modal>
          {this.renderPersonalAddress()}
        </Container>
      </div>
    );
  }
}

PersonalAddressForm.propTypes = PersonalAddressFormProps;

const PersonalAddressFormWrapper = Form.create({ name: 'normal_admin' })(PersonalAddressForm);
export default connect(PersonalAddressFormmapStateToProps, null)(PersonalAddressFormWrapper);
export { PersonalAddressForm, PersonalAddressFormWrapper };



// WEBPACK FOOTER //
// client/containers/IndusindMinKyc/PersonalAddressForm.js